<template functional>
  <div/>
</template>

<script>
export default {
  name: 'Spinner'
}
</script>

<style lang="scss" scoped>
@import '../assets/partials/colors';

div {
  border-radius: 50%;
  border: 3px solid rgba($yellow, .3);
  border-top-color: $yellow;
  height: 28px;
  width: 28px;
  padding: 10px;
  margin: 5px;
  animation: rotation 1s infinite linear;
}

/* rotation keyframe for spinner animations */
@-webkit-keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}
@-moz-keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}
@keyframes rotation {
  to {
    transform: rotate(360deg);
  }
}
</style>
